__turbopack_context__.v({
  "close": "styles-module-scss-module__X5KZWW__close",
});
